import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { BlockComponent } from "@components/container-block/block.component";
import { DatepickerIntervalComponent } from "@components/datepicker-interval/datepicker-interval.component";
import { HeaderComponent } from "@components/header/header.component";
import { InputComponent } from "@components/input/input.component";
import { SelectorComponent } from "@components/selector/selector.component";
import { TranslatePipe } from "@ngx-translate/core";
import { BusyService } from "~app/common/components/busy/busy.service";
import { Kortyp, OmkorningRelationerLagertransaktionRequestDTO } from "~app/common/models/matning/OmkorningRelationerLagertransaktionRequestDTO";
import { DirtyFormService } from "~app/common/services/dirty-form.service";
import { DirtyTabComponent } from "~app/features/regelverk-viol/dirtyTabComponent";
import { ResponsePanelComponent } from "../../components/response-panel/response-panel.component";
import { SystemadministrationService } from "../../systemadministration.service";
import { SystemadministrationTexts } from "../systemadministration-texts";

@Component({
    selector: "rask-sysadm-kundorder",
    templateUrl: "./sysadm-kundorder.component.html",
    styleUrls: ["./sysadm-kundorder.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HeaderComponent,
        BlockComponent,
        InputComponent,
        FormsModule,
        SelectorComponent,
        DatepickerIntervalComponent,
        ResponsePanelComponent,
        ButtonComponent,
        TranslatePipe
    ]
})
export class SysadmKundorderComponent extends DirtyTabComponent implements OnInit {
    antalLagertransaktioner: string;
    korList: { kortnamn: string; kod: Kortyp }[];
    kundorderRequest: OmkorningRelationerLagertransaktionRequestDTO;
    texts: any = SystemadministrationTexts.texts;

    private readonly administrationService = inject(SystemadministrationService);
    private readonly busyService = inject(BusyService);

    constructor() {
        const dirtyFormService = inject(DirtyFormService);

        super(dirtyFormService);
    }

    canSave() {
        // Tom, ingen användning här
    }

    isDirtyCheck(): boolean {
        return false;
    }

    kundorderOmkorning() {
        this.busyService.addWork(this.administrationService.omkorningRelationerLagertransaktion(this.kundorderRequest))
            .subscribe(result => {
                this.antalLagertransaktioner = result.meddelande;
            });
    }

    ngOnInit(): void {
        this.korList = [
            {
                kortnamn: "Alla",
                kod: Kortyp.Alla
            },
            {
                kortnamn: "Saknar kopplad kundorderrad",
                kod: Kortyp.SaknarKundorder
            }
        ];

        this.kundorderRequest = {
            kor: null,
            matdatumFrom: null,
            matdatumTom: null,
            mottagningsplatsNummer: null,
            kundHuvudkodInternnummer: null
        } as OmkorningRelationerLagertransaktionRequestDTO;
    }

    outputFormatter = (result: { kortnamn: string; kod: string }) => result ? result.kod : undefined;

    restoreChanges() {
        // Tom, ingen användning här
    }

    saveChanges() {
        // Tom, ingen användning här
    }

    setMatningFrom = (date: any) => { this.kundorderRequest.matdatumFrom = date; };

    setMatningTom = (date: any) => { this.kundorderRequest.matdatumTom = date; };

    viewFormatter = (result: { kortnamn: string; kod: string }) => result ? result.kortnamn : undefined;
}
